// Regular expression used to identify the message sent by this
// modal. Builds on the assumption that no one else edit these
// properties.
const OUR_MESSAGE_REGEXP = new RegExp(/name|serial|modal/);

export default class CartSettingsController {
    /* @ngInject */
    constructor($log, $scope, $rootScope, $timeout, ThingsService, ShadowService) {
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.ThingsService = ThingsService;
        this.ShadowService = ShadowService;

        this.errorReading = false;
        this.errorWriting = false;
        this.errorConnection = false;
        this.client = undefined;
        this.isClosing = false;
        this.isSaving = false;
        this.currentThingName = '';
        // The settings displayed in the  UI
        this.settings = {
            label: undefined,
            serial: undefined,
            modal: undefined,
        };
        // The Thing properties needed in order to save settings
        this.thing = {
            thingName: undefined,
            domainId: undefined,
            domainPath: undefined,
        };
    }

    $onInit() {
        this.ThingsService.getThing(this.cartId)
        .then((thing) => {
            this.settings.label = thing.label;
            this.currentThingName = thing.label;
            this.settings.serial = thing.shadow.state.reported.serial;
            this.settings.model = thing.shadow.state.reported.model;
            this.thing.domainId = thing.domain.id;
            this.thing.thingName = thing.thingName;
        })
        .then(() => this.ThingsService.getDomains())
        .then((rootDomain) => {
            this.$log.log('Connecting...');
            this.thing.domainPath = rootDomain.resolvePath(this.thing.domainId);
            // The MQTT topic's exposed does not use root as part of the domain path
            this.thing.domainPath = this.thing.domainPath.replace('root/', '');
            return this.ShadowService.connect(this.thing.thingName);
        })
        .then((client) => {
            this.$log.log('Connected!');
            this.client = client;
            this.client.onMessageArrived = this.onMessage.bind(this);
            this.client.onConnectionLost = this.onConnectionLost.bind(this);
            this.client.subscribe(`thing-update/${this.thing.domainPath}/${this.thing.thingName}`);
        })
        .catch((error) => {
            this.$log.info(`Error getting thing: ${error}`);
            this.errorReading = true;
        });
    }

    /**
     * Called from the UI in order to close the modal.
     */
    onClose() {
        this.isClosing = true;
        // This is quite ugly but seems impossible to give the `$hide`
        // method as a binding.
        this.$scope.$parent.$parent.$hide();
        if (this.client !== undefined) {
            try {
                this.client.disconnect();
            } catch (e) {
                this.$log.log('Error closing connection, most likely already closed');
            }
        }
    }

    /**
     * Called from the UI in order to save the cart settings.
     */
    save() {
        this.isSaving = true;
        try {
            if (this.currentThingName !== this.settings.label) {
                // call ThingService (Lambda) to rename
                const params = {
                    thingId: this.cartId,
                    domain: this.thing.domainId,
                    label: this.settings.label,
                };
                this.ThingsService.updateThing(params)
                    .then(() => {
                        // Continue to publish virtual resources to 'thing-update' topic
                        this.sendMessage(angular.copy(this.settings)); // eslint-disable-line
                    })
                    .catch((error) => {
                        this.$log.error('Error renaming cart', error);
                    });
            } else {
                this.sendMessage(angular.copy(this.settings)); // eslint-disable-line
            }
        } catch (e) {
            this.$log.error('Could not write settings');
            this.errorWriting = true;
        }
    }

    sendMessage(settings) {
        delete settings.label;
        const message = new Paho.MQTT.Message('{ "state": { "reported": ' + JSON.stringify(settings) + '}}'); // eslint-disable-line
        message.destinationName = `thing-update/${this.thing.domainPath}/${this.thing.thingName}`;
        this.client.send(message);
    }

    onConnectionLost() {
        if (!this.isClosing) {
            this.$log.error('Connection lost!');
            this.errorConnection = true;
        }
    }

    onMessage(message) {
        // If the message received is accepted write on our request we should close the modal
        this.$log.log(`Received message ${message.payloadString} on topic ${message.destinationName}`);

        if (this.isSaving) {
            if (OUR_MESSAGE_REGEXP.test(message.payloadString)) {
                this.$log.log('Looks like our request...');

                if (message.destinationName.startsWith('thing-update')) {
                    this.$timeout(() => {
                        // Not clear why this timeout is needed? Without it, the updates are not shown in the UI.
                        this.$rootScope.$emit('cartSettingsUpdated');
                        this.onClose();
                    }, 500);
                } else {
                    this.errorWriting = true;
                }
                this.$scope.$apply(); // Callback originates from socket so we need to manually invoke a digest
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/cart-settings/cart-settings.controller.js